/**
 * Store rules. Shipping bands used to live here; they are gone because every
 * book on sale is digital and unlocks in playTUB, so there is nothing to post.
 * Printed copies will need their own shipping model when they are enabled.
 *
 * A promo code used to live here too. Discount codes are now tubstudio's: it
 * defines them and counts how often each has been used, so a code cannot be
 * spent twice by being known in two places. See src/api/coupons.js.
 */
export const STORE = {
  /**
   * The store's own currency, as an ISO code — it prices the shipping bands
   * above, and is the fallback when something carries no currency of its own.
   * It is NOT the currency of the catalogue: publishers price books
   * individually (the live catalogue holds both INR and USD titles), so every
   * price is rendered in the currency that travels with it. Mirrors CURRENCY in
   * backend/.env.
   */
  currency: 'INR',
};

/**
 * Normalised so a stray trailing slash can't break every request.
 *
 * api/client.js builds `${API_BASE_URL}${path}` and every path already starts
 * with "/", so a configured value ending in "/" produces "//api/products".
 * FastAPI does not route that — it answers 404 — and the failure surfaces as an
 * empty catalog rather than as a bad URL, which is a long way from the cause.
 * `.trim()` covers the other half of the same problem: a newline or space picked
 * up from a CI variable or a copy-pasted .env line.
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? '').trim().replace(/\/+$/, '');

/** With no API base configured, every service falls back to bundled mock data. */
export const USE_MOCKS = !API_BASE_URL;

/**
 * True when the API is somewhere other than this machine. The two setups fail
 * for entirely different reasons — a local backend is usually not running, a
 * remote one is usually reachable but rejecting the browser's origin via CORS —
 * so the error UI needs to tell them apart before offering advice.
 */
export const API_IS_REMOTE =
  /^https?:\/\//i.test(API_BASE_URL) &&
  !/^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?(?:\/|$)/i.test(API_BASE_URL);
